module.exports = __webpack_public_path__ + "f2af4dcfab75777eb48755cc07547772.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/SchoolCamps/camps-intro.jpg
// module id = 1223
// module chunks = 0